export const REGEX = {
  INTERNATIONAL: /^(?![:-])[A-Za-zĄČĘĖĮŠŲŪŽąčęėįšųūž0-9/?:().,+'\s"-]*$/ as RegExp,
  CHAR_NUMBER_NO_SPACE: /^[A-Za-z0-9]*$/ as RegExp,
  CUSTOMER_CODE: /^(?=[^ :/-])[A-Za-z0-9/?:().,+'\s"-]*$/ as RegExp,
  ENDS_SLASH: /^(.*[^/])$/ as RegExp,
  SEPA_CHARSET:
    /^[\u0020\u0027-\u0029\u002B-\u003A\u003F\u0041-\u005A\u0061-\u007A\u00A1-\u00A3\u00A7\u00A9\u00B0\u00BF-\u00D6\u00D8-\u00F6\u00F8-\u0107\u010A-\u0113\u0116-\u011F\u0122\u0123\u012A\u012B\u012E-\u0133\u0136\u0137\u0139-\u013E\u0141-\u0148\u0150-\u015B\u015E-\u0165\u016A\u016B\u016E-\u0173\u0178-\u017E\u0218-\u021B\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03CE\u0410-\u042A\u042C\u042E-\u044A\u044C\u044E\u044F\u20AC]*$/u as RegExp,
  TARGET2_CHARSET: /^[\u0020-\u007E]*$/u as RegExp,
};
